/******/ (() => { // webpackBootstrap
class AnimatedBackgroundTextColors extends HTMLElement {
  constructor() {
    super();

    this.blocks = this.querySelectorAll('[data-announcement-block]');
    this.index = 1;
    this.interval = null;
    this.fallbackBackground = this.dataset.fallbackBackground || 'linear-gradient(90deg, #6c7b8d, #07253c, #858585)';
    this.handleBlockSelectBound = this.handleBlockSelect.bind(this);
    this.handleBlockDeselectBound = this.handleBlockDeselect.bind(this);
  }

  connectedCallback() {
    if (!this.blocks.length) return;

    this.init();

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelectBound);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselectBound);
    }
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    document.removeEventListener('shopify:block:select', this.handleBlockSelectBound);
    document.removeEventListener('shopify:block:deselect', this.handleBlockDeselectBound);
  }

  init() {
    clearInterval(this.interval);

    if (this.blocks.length > 1) {
      this.interval = setInterval(this.changeColors.bind(this), 7000);
    }
  }

  applyColors(backgroundColor, frontColor, disableTransition = false) {
    if (disableTransition) this.style.transition = 'none';

    this.style.background = backgroundColor && backgroundColor.trim()
      ? backgroundColor
      : this.fallbackBackground;

    if (frontColor && frontColor.trim()) {
      this.style.color = frontColor;
    }
  }

  changeColors() {
    const activeBlock = this.blocks[this.index];
    if (!activeBlock) return;

    const backgroundColor = activeBlock.getAttribute('data-background-color-block');
    const frontColor = activeBlock.getAttribute('data-front-color-block');

    setTimeout(() => this.applyColors(backgroundColor, frontColor), 350);

    const previousBlock = this.querySelector('[data-announcement-block].active');
    if (previousBlock) previousBlock.classList.remove('active');

    activeBlock.classList.add('active');
    this.index = (this.index + 1) % this.blocks.length;
  }

  handleBlockSelect(event) {
    const block = event.target.closest('[data-announcement-block]');
    if (!block || !this.contains(block)) return;

    const blockIndex = block.dataset.announcementBlockIndex;
    if (blockIndex === undefined) return;

    this.blocks.forEach(item => item.classList.remove('active'));
    block.classList.add('active');

    this.applyColors(
      block.getAttribute('data-background-color-block'),
      block.getAttribute('data-front-color-block'),
      true
    );

    clearInterval(this.interval);
    this.index = Number.parseInt(blockIndex, 10);
  }

  handleBlockDeselect(event) {
    const block = event.target.closest('[data-announcement-block]');
    if (!block || !this.contains(block)) return;

    const blockIndex = block.dataset.announcementBlockIndex;
    if (blockIndex === undefined) return;

    this.style.transition = '';
    this.index = (Number.parseInt(blockIndex, 10) + 1) % this.blocks.length;
    this.init();
  }
}

if (!customElements.get('animated-background-text-colors')) {
  customElements.define('animated-background-text-colors', AnimatedBackgroundTextColors);
}

/******/ })();
